import { Link } from 'react-router-dom';
import { getFeaturedProjects } from '../utils/dataModel';
import ProjectLogo from './ProjectLogo';

const SelectedWork = () => {
  const featured = getFeaturedProjects(6);

  return (
    <section className="projects-content">
      <div className="container">
        <div className="services-header">
          <h2>Selected Work</h2>
          <p className="services-subtitle">
            A few engagements that show the range — a warehouse rebuild, a flood-risk neural
            network, an AI coach that watches you play.
          </p>
        </div>

        <div className="projects-grid">
          {featured.map((project) => (
            <Link
              to={`/work/${project.id}`}
              key={project.id}
              className="project-card-link"
            >
              <div className="project-card">
                <div className="project-logo">
                  <ProjectLogo project={project} />
                </div>
                <h3>{project.title}</h3>
                <p className="project-client">{project.client_name}</p>
                {project.headline_outcome && (
                  <p className="project-outcome">{project.headline_outcome}</p>
                )}
                <p className="project-summary">{project.problem_statement}</p>
                <span className="project-link-text">View project →</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="services-footer">
          <Link to="/work" className="btn btn-secondary">See all work</Link>
        </div>
      </div>
    </section>
  );
};

export default SelectedWork;
